import type {
  GsnIntegrationSettings,
  JournalIntegrationTagKind,
} from "./types";

const hasSettingsMismatchFlag = (settings?: GsnIntegrationSettings) => {
  if (!settings) return false;

  return (
    settings.isMismatch === true ||
    settings.isOutdated === true ||
    settings.isSettingsChanged === true ||
    settings.isActual === false
  );
};

export const getJournalIntegrationTagKind = ({
  titleStatus,
  settings,
  isSettingsLoaded,
}: {
  titleStatus?: string;
  settings?: GsnIntegrationSettings;
  isSettingsLoaded: boolean;
}): JournalIntegrationTagKind | null => {
  if (titleStatus === "DOCUMENT_ERROR") {
    return "document-error";
  }

  if (titleStatus === "INTERACTION_ERROR_WITH_GSN") {
    return "interaction-error";
  }

  if (!isSettingsLoaded) {
    return null;
  }

  if (hasSettingsMismatchFlag(settings)) {
    return "settings-mismatch";
  }

  if (!settings?.isEnabled) {
    return "no-integration";
  }

  return "integration-ok";
};
